// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-element {\r\n  \r\n}\r\n\r\n.form-element > textarea {\r\n  max-width: 250px;\r\n}", "",{"version":3,"sources":["webpack://./src/styles/custom-form.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".form-element {\r\n  \r\n}\r\n\r\n.form-element > textarea {\r\n  max-width: 250px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
